import { BaseModel } from '../../base.model';

/**
 * Response body for a successful (201) POST /api/emem/equipment (WI 32008).
 * The 404 (source missing) and 409 (duplicate code/VIN, or a new category with no
 * cost management) outcomes arrive as an HttpErrorResponse with a message string,
 * so the caller branches on the HTTP status; this shape is the created payload.
 */
export class DuplicateEquipmentResultDto extends BaseModel {
  /** Outcome code (0 = Created on the success path). */
  public Status: number;

  /** The new record's SQL-assigned KeyId. */
  public NewKeyId: number;

  /** Equipment company of the new record. */
  public EquipmentCompany: number;

  /** New equipment code. */
  public EquipmentName: string;

  /** Category of the new record. */
  public EquipmentCategory: string;

  /**
   * For a 409 on a category with no cost management (bEMCM): true when it is the
   * source's own category, false when the user chose a different one. A
   * duplicate never creates cost management; Vista owns that setup.
   */
  public IsSourceCategory: boolean;
}
